import config from 'configs/app';

const maxWidthVerticalNavigation = config.UI.maxContentWidth ? 1_920 : 10_000;

export const CONTENT_MAX_WIDTH = config.UI.navigation.layout === 'horizontal' ? 10_000 : maxWidthVerticalNavigation;
